import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {RequestFormType} from "../../../app/tools/request-forms2/const/const";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";
import {QuickAddItemType} from "../../../app/quick-add/@types";


export class PublicFormsModule extends ModuleProto {

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.PUBLIC_FORMS, moduleConfig);

        this.name                    = "Public Forms"
        this.description             = "The Public Forms module allows organizations to create and share customizable forms with external stakeholders or the public."
        this.svgIcon                 = "isvg-forms"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Productivity & collaboration"
        this.settingsUrl             = "settings/forms"
        this.parentSection          = SettingsParentSection.PRODUCTIVITY

        this.feature                = Feature.FORMS
        this.validateFeature()

    }


    toJson() {
        const result = super.toJson();

        return result
    }

    newForm(projectId?:ID) {
        gd.openNew(QuickAddItemType.REQUEST_FORM, {type: RequestFormType.FORM, projectId});
    }

    goToSettings() {
        gd.goTo('settings/forms')
    }

    goToList() {
        gd.goTo('o/forms')
    }

}